import { CollectionView } from '@casops/components/layout/collection-view/CollectionView';
import { ModelName } from '@casops/store/api';
import {
  RegisteredAssetDetailModel,
  useGetAssetQuery,
} from '@casops/store/apis/registeredAssetsApi';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import { useDeviceMessagesColumnDefs } from '@casops/hooks/useDeviceMessagesColumnDefs';
import {
  DeviceMessageModel,
  useGetListDeviceMessagesForAssetQuery,
} from '@casops/store/apis/deviceMessagesApi';
import { skipToken } from '@reduxjs/toolkit/query';

type Model = DeviceMessageModel;

const API_TABLE_LIMIT = 50;

const modelName = ModelName.DeviceMessage;

export function AssetDiagnostics() {
  const { t } = useTranslation();

  const { data } = useOutletContext<{
    data: RegisteredAssetDetailModel | undefined;
    requestRemainder: Omit<ReturnType<typeof useGetAssetQuery>, 'data'>;
  }>();

  const columnDefs = useDeviceMessagesColumnDefs(false);

  const noResultsDescription = t('Model.Collection.NoItems', { modelName });

  const { data: deviceMessages } = useGetListDeviceMessagesForAssetQuery(data?.id ?? skipToken, {
    refetchOnMountOrArgChange: 60,
  });

  const sliceKey = `${modelName}--${data?.id}`; // Create a unique sliceKey for each asset's device messages table.

  return (
    <CollectionView<Model>
      sliceKey={sliceKey}
      modelName={modelName}
      columnDefs={columnDefs}
      rowData={deviceMessages}
      hasData={deviceMessages !== undefined}
      noDataDescription={noResultsDescription}
      apiResultLimit={API_TABLE_LIMIT}
    />
  );
}

export default AssetDiagnostics;
